import React from 'react';

import Card from "@material-ui/core/Card";
// eslint-disable-next-line
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import { makeStyles } from "@material-ui/styles";
// eslint-disable-next-line
import Divider from "@material-ui/core/Divider";
import { useTranslation } from "react-i18next";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
    card: {
        height: '100%',
        borderTop: 'none',
        borderLeft: 'none',
        borderRight: 'none',
        borderRadius: 0
    },
    cardSelected: {
        backgroundColor: `transparent`
    },
    cardHeaderRoot: {
        padding: theme.spacing(2, 1)
    },
    cardHeaderTitle: {
        fontSize: '0.875rem',
         },
    cardContent: {
        padding: 0
    },
    listRoot: {
        padding: 0
    }
}))

const AktyCard = ({ akt, selected, noTitle }) => {
    const classes = useStyles();
    const { t } = useTranslation();
    return (
        <div style={{ height: '100%' }}>
            <Card variant="outlined" className={clsx(classes.card, selected && classes.cardSelected)}>

                <CardContent className={classes.cardContent}>
                    <List className={classes.listRoot} dense>
                        <ListItem dense >
                            <ListItemText
                                primary={<>
                                    {noTitle ? '' : <><b>{t('akt.title')}</b>{':'}<br /></>}
                                    <small>&nbsp;&nbsp;<b>{t('akt.nazwa')}</b>: {akt.nazwa}</small>
                                </>}
                                secondary={<>
                                    <small>&nbsp;&nbsp;<b>{t('akt.miejsce_publikacji')}</b>: {akt.miejsce_publikacji}</small><br />
                                    <small>&nbsp;&nbsp;<b>{t('akt.typ')}</b>: {akt.typ}</small><br />
                                    <small>&nbsp;&nbsp;<b>{t('akt.rodzaj')}</b>: {akt.rodzaj}</small><br />
                                </>}
                            />
                        </ListItem>
                    </List>
                </CardContent>
            </Card>
        </div>
    );
}

export default AktyCard
